/* ============================================================
   CYNTHIA COFFIELD STUDIO — MOTION SYSTEM (JS)
   IntersectionObserver reveals, staggered 90ms within a group.
   Fires once per element, then lets go. ~1.5KB, no dependencies.
   ============================================================ */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced || !("IntersectionObserver" in window)) return; // everything stays visible

  // Signal to CSS that JS is alive — only now may elements be hidden
  document.documentElement.classList.add("cc-js");

  var STAGGER = 90;   // ms between siblings
  var MAX_DELAY = 540; // cap so long grids don't crawl

  function init() {
    // --- Candidates -------------------------------------------------
    // Artwork / product cards (wash reveal)
    var cards = document.querySelectorAll(".card-wrapper, .grid__item .card");
    // Text + media blocks (plain rise)
    var blocks = document.querySelectorAll(
      ".rich-text__blocks, .image-with-text__media, .image-with-text__content, " +
      ".newsletter__wrapper, .multicolumn-card, .collection-list .card-wrapper"
    );
    // Section headings (rise + drawn rule)
    var titles = document.querySelectorAll(
      ".title-wrapper-with-link .title, .section > .title, h2.title"
    );

    cards.forEach(function (el) {
      el.classList.add("cc-reveal", "cc-wash");
    });
    blocks.forEach(function (el) {
      el.classList.add("cc-reveal");
    });
    titles.forEach(function (el) {
      el.classList.add("cc-reveal", "cc-rule");
      var wrap = el.closest(".center, .title-wrapper--center");
      if (wrap || /center/.test(el.className)) el.classList.add("cc-rule--center");
    });

    // --- Stagger: index within shared parent ------------------------
    var groups = new Map();
    document.querySelectorAll(".cc-reveal").forEach(function (el) {
      var parent = el.parentElement
        ? (el.parentElement.closest("ul, .grid, .multicolumn-list, section") || el.parentElement)
        : document.body;
      var i = groups.get(parent) || 0;
      el.style.transitionDelay = Math.min(i * STAGGER, MAX_DELAY) + "ms";
      groups.set(parent, i + 1);
    });

    // --- Observe -----------------------------------------------------
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("cc-inview");
            io.unobserve(entry.target); // reveal once, then be still
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );

    document.querySelectorAll(".cc-reveal").forEach(function (el) {
      // If already in view on load (above the fold), reveal with its stagger
      io.observe(el);
    });

    // Safety net: anything still hidden after 4s becomes visible.
    setTimeout(function () {
      document.querySelectorAll(".cc-reveal:not(.cc-inview)").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("cc-inview");
      });
    }, 4000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
